import { Checkbox } from "@/components/ui/checkbox";

interface ClientListHeaderProps {
  checked: boolean;
  indeterminate: boolean;
  onCheckedChange: () => void;
}

export function ClientListHeader({
  checked,
  indeterminate,
  onCheckedChange,
}: ClientListHeaderProps) {
  return (
    <div className="grid h-[52px] grid-cols-[auto_0.7fr_1fr_1fr_120px] items-center gap-4 px-5 py-2">
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        onCheckedChange={onCheckedChange}
        className="border-white"
      />

      <p className="text-black-500 text-xs leading-[12px] font-medium tracking-normal uppercase">
        NAME
      </p>

      <p className="text-black-500 text-xs leading-[12px] font-medium tracking-normal uppercase">
        EMAIL
      </p>

      <p className="text-black-500 text-xs leading-[12px] font-medium tracking-normal uppercase">
        SUBSCRIPTION
      </p>

      <p className="text-black-500 text-xs leading-[12px] font-medium tracking-normal uppercase">
        ACTIVE UNTIL
      </p>
    </div>
  );
}
